<template>
  <BasicModalWindow
    ref="modal_element"
    class="message-move"
    :title="modal_title"
    :gtm="{
      module : 'folders',
      feature: 'folders_move_modal',
      block  : 'modal_header',
      action : 'cancel'
    }"
  >
      <template #pre-body v-if="folders_collapse_collection.count > 0">
        <InputSearch
            ref="input_search_component"
            class="contacts-search"
            @inputSearchSet='onInputSearchSet'
            @inputSearchClear='onInputSearchClear'
        />
      </template>

      <template #body>
          <FoldersListCollapsable v-if="folders_search_collection.search_active === false && folders_collapse_collection.count > 0"
            selection_box="radio"
            list_type="selection"
            :folders_collapse_collection='folders_collapse_collection'
            :folders_selection_collection='folders_selection_collection'
            :folders_disabled='folders_disabled'
          />

          <FoldersListSearch v-else-if="folders_search_collection.count > 0"
            selection_box="radio"
            list_type="selection"
            :folders_search_collection='folders_search_collection'
            :folders_selection_collection='folders_selection_collection'
            :folders_disabled='folders_disabled'
          />

          <ContentEmpty v-else
            text="folders.empty_folders"
            icon="fas fa-folder"
          />
      </template>

      <template #footer>
           <ActionButton
              @click="onFolderMove()"
              icon="fa fa-folder-open"
              class='main-action push-right'
              :disabled="!folders_selection_collection.count"
              text="folders.actions.move"
              :gtm="{
                module : 'folders',
                feature: 'folders_move_modal',
                block  : 'modal_footer',
                action : 'submit'
              }"
          />
      </template>
  </BasicModalWindow>
</template>

<script setup>
  import {ref, reactive}             from 'vue';
  import {defineProps}               from 'vue';
  import {onBeforeMount}             from 'vue';
  import FoldersListCollapsable      from '../Partials/FoldersListCollapsable.vue';
  import FoldersListSearch           from '../Partials/FoldersListSearch.vue';
  import BasicModalWindow            from '@/vue/Layouts/Modals/BasicModalWindow.vue';
  import ActionButton                from '@/vue/Elements/Buttons/ActionButton.vue'
  import InputSearch                 from '@/vue/Elements/Inputs/InputSearch.vue'
  import ContentEmpty                from '@/vue/Elements/Content/ContentEmpty.vue';
  import FoldersController           from '@/js/Mailboxes/FoldersController';
  import FoldersCollapseCollection   from '@/js/Mailboxes/Collections/FoldersCollapseCollection';
  import FoldersSearchCollection     from '@/js/Mailboxes/Collections/FoldersSearchCollection';
  import CollectionList              from '@/js/Shared/Collections/CollectionList';
  import Language                    from '@/js/Shared/Language/Language.js';

  const props = defineProps({
    selected_folder : {
      required: true,
    }
  })

  const modal_element            = ref();
  const input_search_component   = ref();
  const folders_disabled         = ref({});

  const folders_controller           = FoldersController
  const folders_search_collection    = reactive(new FoldersSearchCollection());
  const folders_collapse_collection  = reactive(new FoldersCollapseCollection('move_modal'));
  const folders_selection_collection = reactive(new CollectionList('id'));
  const modal_title                  = Language.say('folders.move.title', [props.selected_folder.name]);

  onBeforeMount(() => {
    folders_controller.section_state.onLoad('fetch_all', async () => {
      setCollectionModifiers();
      setCollectionLists();
      setDisabledFolders();
    })
  })

  const onInputSearchSet = (term) => {
    folders_search_collection.search(term);
  }

  const onInputSearchClear = (term) => {
    folders_search_collection.reset();
  }

  const onFolderMove = async () => {
    let success = await moveFolder();

    if (success) {
      modal_element.value.close();
    }
  }

  const moveFolder = async () => {
    return await folders_controller.move(
      folders_selection_collection.getFirst(),
      props.selected_folder
    );
  }

  const setCollectionModifiers = () => {
    folders_collapse_collection.setModifier('add_top_folder')
  }

  const setCollectionLists = () => {
    folders_collapse_collection.setFolders(folders_controller.mailboxes.folders.custom);
    folders_search_collection.setSearchList(folders_controller.mailboxes.folders.custom);
  }

  const setDisabledFolders = () => {
    folders_disabled.value = folders_controller.getDisabledFolders(props.selected_folder);
  }
</script>
